import { useEffect } from 'react'
import BasePartner from './BasePartner'

export default class BIDVPartner extends BasePartner {
  usePaymentPageEffect({ location, setErrorMessage }) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      const searchParams = new URLSearchParams(location.search)
      const status = searchParams.get('status')

      if (status === '-1' || status === '0') {
        setErrorMessage({
          title: 'Thanh toán thất bại',
          content: 'Quá trình thanh toán đã bị huỷ hoặc có lỗi xảy ra. Vui lòng thử lại.'
        })
        
        searchParams.delete('status')
        const newSearch = searchParams.toString()
        const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`
        window.history.replaceState({}, '', newUrl)
      }
    }, [location.pathname, location.search, setErrorMessage])
  }

  getPaymentMethodApiPayload({ apikey }) {
    return apikey ? { apikey } : {}
  }

  processPaymentMethods(methods, currentPaymentMethodType, appThemeName) {
    const { filteredData } = super.processPaymentMethods(methods, currentPaymentMethodType, appThemeName)
    
    let initialMethod = filteredData.length > 0 ? filteredData[0] : null
    const bidvMethod = filteredData.find(item => item.paymentTypeCode === 'BIDV_INAPP')
    
    if (bidvMethod) {
      initialMethod = bidvMethod
    }
    
    return {
      filteredData,
      initialMethod
    }
  }

  getRedirectUrls(orderId) {
    return {
      returnPath: '/',
      cancelPath: `/auto-traffic-fine-notification/payment?orderId=${orderId}`
    }
  }

  handlePostPaymentResponse({ paymentResponse, setIsSubmitting, redirectToExternalPayment, setErrorMessage }) {
    if (paymentResponse?.data?.paymentGatewayData) {
      setIsSubmitting(false)
      const payloadString = JSON.stringify(paymentResponse.data.paymentGatewayData)
      if (window?.webkit?.messageHandlers?.appEvent?.postMessage) {
        window.webkit.messageHandlers.appEvent.postMessage(payloadString)
      } else if (window?.android?.appEvent) {
        window.android.appEvent(payloadString)
      }
      return { handled: true }
    }
    
    return super.handlePostPaymentResponse({ paymentResponse, setIsSubmitting, redirectToExternalPayment, setErrorMessage })
  }
}
